import React from 'react';

import { useThemeLayoutConfig } from 'config/ThemeDashboardLayoutConfig';

import { tintWithWhite } from '../utils/color';

/**
 * Las variables de marca del módulo, listas para aplicar como `style`.
 *
 * El tema es dinámico por compañía pero antd corre SIN `cssVar`, así que no
 * existe ninguna `--ant-color-*` en el documento: el color hay que bajarlo
 * desde el hook y publicarlo a mano.
 *
 * Existe como hook —y no como una constante— porque hay que aplicarlo en MÁS DE
 * UN LUGAR. La vista lo pone en su div raíz, pero los modales de antd se
 * portean a `document.body`, fuera de ese div, así que la cascada no los
 * alcanza y cada uno tiene que publicar las suyas. Un modal sin esto se pinta
 * con el color de reserva del SCSS: en la compañía cuyo primario coincide con
 * ese valor pasa desapercibido, y en cualquier otra el modal sale de un color y
 * la pantalla de atrás de otro.
 *
 * Sólo alcanza a lo que es MARCA. Los colores de estado son semánticos y viven
 * fijos en el SCSS: con un primario rojo, "ejecutada" pintada con el primario
 * diría lo contrario de lo que pasó.
 */
export const useRouteReportTheme = (): React.CSSProperties => {
  const { theme } = useThemeLayoutConfig();
  const primary = theme?.token?.colorPrimary;

  return {
    '--rr-primary': primary,
    /* Derivado del primario real, no de `Menu.itemSelectedBg`: ese cae al token
       base de antd —azul— cuando la BD no lo define, y teñiría de azul el
       realce de una compañía teal. */
    '--rr-primary-bg': tintWithWhite(primary),
  } as React.CSSProperties;
};
